import React from "react";
import { get, toArray } from "../../../../utils";
import { urlToFile } from "../../../../utils/upload/uploadFile";
import { isEqual } from "lodash";

export const listTyleEmum = {
  text: "text", // 文本模式
  thumb: "picture", // 缩略图模式
  imgs: "picture-card", // 照片墙模式
  video: "picture-card", // 照片墙模式
};

/**
 * 当组件平静后显示的图片
 *
 * @param {*} props
 * @param {*} state
 * @returns
 */
export const staticFileList = function (props, state, uploadFile) {
  let limit = props.limit || undefined;
  let propsList = get(props, "list", null);
  if (propsList instanceof Array || propsList == null) {
    const stateList = get(state, "fileListByForm");
    let currentList = toArray(propsList || stateList || []);
    let fileList = [];
    const list = currentList.slice(0, limit);
    fileList = list.map((file, index) => {
      if (typeof file === "string") {
        return urlToFile(file, -1 * index - 1);
      }
      return file;
    });
    return fileList;
  } else {
    console.warn("传入的url列表必须是数组，当前是", propsList);
    return [];
  }
};

/**
 * 上传规则限制
 *
 * @param {File} file 文件对象
 * @param {Array} fileList 文件对象列表
 * @param {*} props
 * @returns
 */
export const uploadRules = function (file, fileList, props) {
  const { fileSize, limit } = props;
  const fileNumber = get(fileList, "length", 0) + 1;
  const condtions = [
    // 当返回 true 代表校验通过
    {
      rule: () => fileSize === 0 || file.size / (1024 * 1024) <= fileSize,
      message: props.message.fileSize,
    },
    {
      rule: () =>
        limit === 0 || (fileList.length <= limit && fileNumber <= limit),
      message: props.message.limit,
    },
  ];
  const customUploadRules = get(props, "uploadRules", []);
  for (let condtion of condtions.concat(customUploadRules)) {
    if (!condtion.rule(file)) {
      condtion.message(file, fileList);
      return false;
    }
  }
  return true;
};

const getUploadItems = function (id) {
  return [
    ...document
      .querySelector(`#${id}`)
      .querySelectorAll(".ant-upload-list .ant-upload-list-item-done"),
  ];
};

let dragIndex = null;

export const dragControl = function (id, props, EventEmitter) {
  if (get(props, "soft", false) !== true) return;
  getUploadItems(id).forEach((dom) => {
    const draggable = dom.getAttribute("draggable");
    if (draggable == null) {
      dom.setAttribute("draggable", true);
      dom.ondrop = (e) => {
        e.preventDefault();
      };
      dom.ondragend = (e) => {
        e.preventDefault();
        const list = getUploadItems(id);
        const index = list.findIndex((d) => d === dom);
        EventEmitter.emit("dragOver", { dragIndex, index });
      };
      dom.ondragenter = (e) => {
        e.preventDefault();
      };
      dom.ondragover = (e) => {
        e.preventDefault();
        const list = getUploadItems(id);
        const index = list.findIndex((d) => d === dom);
        dragIndex = index;
      };
    }
  });
};

/**
 * 当展示类型为视频时，控制逻辑
 *
 * @param {*} props
 * @param {*} id
 */
export const videoControl = function (props, id) {
  const type = get(props, "type", "img");
  const showType = get(props, "showType", null);
  if ((type || showType) === "video") {
    const parent = document.querySelector(
      `#${id} .yx_upload_box .ant-upload-list`
    );
    const videos = parent.querySelectorAll(".ant-upload-list-item-done");
    videos.forEach((video) => {
      const videoIdent = video.getAttribute("videoident");
      const card = video.querySelector(".ant-upload-list-item-info>span>a");
      const href = get(card, "href", null);
      if (href != null && videoIdent == null) {
        video.setAttribute("videoident", "change");
        card.setAttribute("src", card.getAttribute("href"));
        card.outerHTML = card.outerHTML.replace("<a", "<video");
      }
    });
  }
};

/**
 * 如果有表单，则设置表单的值
 *
 * @param {*} props
 */
export const setFieldValue = function (props, callback) {
  const form = get(props, "form", null);
  const list = get(props, "list", null);
  if (form != null && list instanceof Array) {
    const id = get(props, "id");
    const extraList = get(props, "extraList", []);
    const arr = extraList.concat(list);
    form.setFieldsValue({ [id]: arr }, () => callback(arr));
  }
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/BaseUpload/tools.js